var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center error_page"},[_c('v-divider'),_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v(" ¡ No Autorizado ! ")]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }